import Vue from 'vue';

export default new Vue();



// WEBPACK FOOTER //
// ../globals/eventBus.js